// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation{to{stroke-dashoffset:0}}.widget-container{bottom:5%;cursor:pointer;height:auto;opacity:1;position:fixed;right:1%;width:auto;z-index:100}.widget-container .wrapper{align-items:center;display:flex;flex-direction:column}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
